import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { STORE_PHONE_PRIMARY } from "../../constants/storeContact";
import "./FloatingWhatsAppCta.css";

const whatsappPhone = STORE_PHONE_PRIMARY.tel.replace(/^\+/, "");
const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsappPhone}`;

export default function FloatingWhatsAppCta() {
  return (
    <a
      className="floatingWhatsAppCta"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Gem Fashion Studios on WhatsApp"
    >
      <FaWhatsapp aria-hidden />
      <span>WhatsApp</span>
    </a>
  );
}

export { whatsappUrl };
